import { ContextService } from '../../../services/context_service';
import { lazyInject } from '../../../services/inversify';
import { PvToolErzeugungsLastdatenImport } from './PvToolErzeugungsLastdatenImport';
import { PvToolErzeugungsLastdatenTabelle } from './PvToolErzeugungsLastdatenTabelle';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface PvToolErzeugungsLastdatenProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface PvToolErzeugungsLastdatenState {
    tabIndex: number;
}

export class PvToolErzeugungsLastdaten extends React.Component<PvToolErzeugungsLastdatenProps, PvToolErzeugungsLastdatenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.pv_tool'/*'admin.tab.pv_tool.daten'*/;
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_ERZEUGUNGSDATEN_LASTDATEN_TABELLE },
        { path: RoutingIDs.ROUTE_ERZEUGUNGSDATEN_LASTDATEN_IMPORT }
    ];
    private tabs: string[] = ['daten', 'daten']; // Reitereihenfolge beachten

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-pv_tool'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.daten}>Tabelle</Tab>
                    <Tab disabled={!this.rechte.daten}>Import</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.daten &&
                        <PvToolErzeugungsLastdatenTabelle />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.daten &&
                        <PvToolErzeugungsLastdatenImport data={this.props.data} />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
